import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const musterListApi = baseApi.injectEndpoints({

    endpoints: (builder) => ({
        getEmployeeMuster: builder.query({
            query: ({ empId, yearMonth, sortDirection, page, size, search }) =>
                ({url: API_ENDPOINTS.ATTENDANCE.GET_EMPLOYEE_ATTENDANCE_MUSTER(empId, yearMonth, sortDirection, page, size, search)}),
            providesTags: ["Muster"],
        }),

        getEmployeeMusterList: builder.query({
            query: () =>({url: API_ENDPOINTS.ATTENDANCE.GET_EMPLOYEE_ATTENDANCE_MUSTER_LIST()}),
            providesTags: ["Muster"],
        }),

        getMusterDynamicHeaders: builder.query({
            query: () =>({url: API_ENDPOINTS.ATTENDANCE.GET_MUSTER_DYNAMIC_HEADERS()}),
            providesTags: ["Muster"],
        }),
    }),
});

export const { useGetEmployeeMusterQuery, useGetEmployeeMusterListQuery, useGetMusterDynamicHeadersQuery } = musterListApi;
